import { forwardRef } from 'react'
import classnames from 'classnames'

// Mirrors @wetu/design-system-components ChoiceCard as a soft, vertical block card.
// icon is a rendered element so existing svg/feather icons can be passed in.
const ChoiceCard = forwardRef(({ icon, heading, body, className, ...props }, ref) => {
    return (
        <button ref={ref} type="button" className={classnames('ds-choice-card', className)} {...props}>
            <span className="ds-choice-card__heading">
                {icon && <span className="ds-choice-card__icon" aria-hidden="true">{icon}</span>}
                {heading}
            </span>
            {body && <span className="ds-choice-card__body">{body}</span>}
        </button>
    )
})

ChoiceCard.displayName = 'ChoiceCard'

export default ChoiceCard
